// extracted by mini-css-extract-plugin
export var logo = "styles-module--logo--2CI0A";
export var menuLink = "styles-module--menuLink--13ZlV";
export var active = "styles-module--active--3YjVr";